const isMobile = /(android|ios|ipod|ipad|iphone)/gi.test(navigator.userAgent)

// DOM helpers. :-)
const _$ = {
	create: function (tag, className, id) {
		let obj = document.createElement(tag)
		obj.id = id || ''
		obj.className = className || ''
		return obj
	},
	all: function (query) {
		return document.querySelectorAll(query)
	}
}

let currentGroup = []
let currentIndex = 0

// DOM elements.
const dom = function () {
	let obj = {
		overlay: _$.create('ui-lightbox'),
		content: _$.create('content'),
		description: _$.create('span', 'description'),
		image: _$.create('div', 'image'),
		title: _$.create('span', 'title'),
		texts: _$.create('div', 'texts'),
		next: _$.create('div', 'next'),
		prev: _$.create('div', 'prev'),
		close: _$.create('div', 'close')
	}

	if (isMobile) {
		obj.overlay.classList.add('mobile')
	}

	obj.overlay.appendChild(obj.content)

	obj.content.appendChild(obj.image)
	obj.content.appendChild(obj.next)
	obj.content.appendChild(obj.prev)
	obj.content.appendChild(obj.texts)

	obj.texts.appendChild(obj.title)
	obj.texts.appendChild(obj.description)

	obj.overlay.appendChild(obj.close)

	return obj
}()

document.addEventListener('DOMContentLoaded', init)

// Private functions.

function init() {
	document.body.appendChild(dom.overlay)

	dom.overlay.addEventListener('click', function (event) {
		if (event.srcElement == this || event.target == this) {
			event.preventDefault()
			close()
		}
	})

	dom.next.addEventListener('click', next)
	dom.prev.addEventListener('click', previous)
	dom.close.addEventListener('click', close)

	// Add global click.
	document.body.addEventListener('click', (event) => {
		// Find the first parent with the `lb` attribute.
		let node = event.target

		while (node instanceof HTMLElement) {
			if (node.hasAttribute('lb')) {
				onClick.call(node, event)
				break
			}

			node = node.parentNode
		}
	})
}

function onClick(event) {
	event.preventDefault()

	let items = []
	let index = null

	// Group? Collect them all.
	let group = this.getAttribute('lb-group')
	if (group) {
		let elements = document.querySelectorAll('[lb-group=' + group + ']')

		// Find `this`.
		for (let a = 0; a < elements.length; a++) {
			let item = {
				description: elements[a].getAttribute('lb-description'),
				src: elements[a].getAttribute('lb-src'),
				title: elements[a].getAttribute('lb-title')
			}
			items.push(item)

			if (elements[a] == this) {
				index = a
			}
		}

		open(items, index)
	}
	else {
		const item = {
			description: this.getAttribute('description'),
			src: this.getAttribute('href') || this.getAttribute('src'),
			title: this.getAttribute('title')
		}
		open([item], 0)
	}
}

function setContent() {
	if (currentGroup.length) {
		let item = currentGroup[currentIndex]

		dom.image.innerHTML = ''

		// Images.
		if (/\.(png|jpg|jpeg|gif|bmp)$/gi.test(item.src)) {
			let image = new Image()
			image.onload = function () {
				dom.content.classList.add('show')
				dom.title.textContent = item.title || ''
				dom.description.textContent = item.description || ''
				dom.image.style.backgroundImage = 'url(\'' + this.src + '\')'
			}
			image.src = item.src
		}
		// Vimeo video.
		else if (/(vimeo\.com)/i.test(item.src)) {
			const iframe = document.createElement('iframe')
			iframe.allowFullscreen = true
			iframe.src = 'https://player.vimeo.com/video/' + /([0-9]+)/.exec(item.src)[0]
			dom.image.appendChild(iframe)
			dom.content.classList.add('show')
		}

		const canGoPrev = currentIndex > 0
		const canGoNext = currentGroup.length > 1 && currentIndex < (currentGroup.length - 1)
		dom.prev.classList[canGoPrev ? 'remove' : 'add']('disabled')
		dom.next.classList[canGoNext ? 'remove' : 'add']('disabled')
	}
	else {
		dom.content.className = ''
	}
}

// Public functions

// Two ways to call this function:
// open(array, index)
// open(image, title, description)
function open(...argv) {
	dom.overlay.style.display = 'block'

	let items = argv[0]
	let index = argv[1]

	// image url + description
	if ('string' === typeof argv[0]) {
		items = [{
			description: argv[2],
			src: argv[0],
			title: argv[1]
		}]
		index = 0
	}

	if (!items.length) {
		throw new Error('Nothing to show!')
	}

	currentGroup = items
	currentIndex = index
	setContent()

	dom.overlay.classList.add('show')
	return this
}

function close() {
	setTimeout(function () {
		dom.overlay.style.display = 'none'
	}, 300)

	dom.overlay.classList.remove('show')
	dom.image.innerHTML = ''
	currentGroup = []
	currentIndex = 0
	setContent()
	return this
}

function next() {
	if (currentIndex < currentGroup.length - 1) {
		currentIndex++
		setContent()
	}
}

function previous() {
	if (currentIndex > 0) {
		currentIndex--
		setContent()
	}
}

// Return public properties.
export {
	open,
	close,
	next,
	previous,
}